import { render, staticRenderFns } from "./BoxPassword.vue?vue&type=template&id=77e36bf6&scoped=true&"
import script from "./BoxPassword.vue?vue&type=script&lang=js&"
export * from "./BoxPassword.vue?vue&type=script&lang=js&"
import style0 from "./BoxPassword.vue?vue&type=style&index=0&id=77e36bf6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e36bf6",
  null
  
)

export default component.exports